<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import type { ColumnProps, ColumnSlots } from 'primevue/column';
import Column from 'primevue/column';

const props = withDefaults(
  defineProps<{
    field: ColumnProps['field']; // is opzettelijk verplicht omdat sommige developers het lastig vinden om in te schatten wanneer een value nodig is
    header?: ColumnProps['header'];
    sortable?: ColumnProps['sortable'];
    sortField?: ColumnProps['sortField'];
    rowReorder?: ColumnProps['rowReorder'];
    expander?: ColumnProps['expander'];
    class?: ColumnProps['class'];
    headerClass?: ColumnProps['headerClass'];
    frozen?: ColumnProps['frozen'];
    align?: keyof typeof columnAlign;
    pt?: ColumnProps['pt'];
    ptOptions?: ColumnProps['ptOptions'];
  }>(),
  { align: 'left' },
);

const slots = defineSlots<ColumnSlots>();

const slotNames = Object.keys(slots) as Array<keyof ColumnSlots>;

const columnAlign = {
  left: '',
  center: 'justify-items-center text-center',
  right: 'justify-items-end text-right',
};
</script>

<template>
  <!-- Hotfix 'v-if="true"' until https://github.com/primefaces/primevue/issues/5360 is solved -->
  <!-- eslint-disable-next-line vue/no-constant-condition -->
  <Column v-if="true" v-bind="props">
    <template #sorticon="{ class: sorticonClass, sorted, sortOrder }">
      <FontAwesomeIcon
        v-show="sorted"
        :class="[sorticonClass, 'text-sm']"
        :icon="['far', `arrow-${sortOrder > 0 ? 'down-short-wide' : 'up-wide-short'}`]"
      />
    </template>

    <template v-for="slotName in slotNames" :key="slotName" #[slotName]="slotProps">
      <div :class="columnAlign[props.align]">
        <slot :name="slotName" v-bind="slotProps as any"></slot>
      </div>
    </template>
  </Column>
</template>
